// Copyright (c) StrangeBee 2023

import { PossibleNamedQuery, QuerySelector, ObjectTypeV1 } from 'thehive-sdk';

const mapObjectTypeToQuery: Record<
    Extract<
        ObjectTypeV1,
        ObjectTypeV1.CASE | ObjectTypeV1.ALERT | ObjectTypeV1.CASE_STATUS | ObjectTypeV1.ALERT_STATUS
    >,
    PossibleNamedQuery
> = {
    case: 'listCaseStatus',
    alert: 'listAlertStatus',
    caseStatus: 'listCaseStatus',
    alertStatus: 'listAlertStatus',
};

export interface ListSelectorParams {
    entity: Extract<
        ObjectTypeV1,
        ObjectTypeV1.CASE | ObjectTypeV1.ALERT | ObjectTypeV1.CASE_STATUS | ObjectTypeV1.ALERT_STATUS
    >;
}

export const computeListSelector = ({ entity }: ListSelectorParams): QuerySelector => ({
    head: [{ name: mapObjectTypeToQuery[entity] }],
    extraData: ['canDelete'],
    name: `get-all-${entity}-status`,
    sort: ['-stage', '+value'],
});
